import { Component } from "react";

// Catches render errors so users see a message + reload instead of a white page.
export class ErrorBoundary extends Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error("Render error:", error, info?.componentStack); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center bg-white p-8" data-testid="app-error-boundary">
        <div className="max-w-lg border border-black p-8">
          <div className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground">Something went wrong</div>
          <h1 className="text-2xl font-black tracking-tight mt-2">This page hit an error</h1>
          <p className="text-sm text-muted-foreground mt-3">Your data is safe. Reload the page; if it keeps happening, send PostWage support the message below.</p>
          <pre className="mt-4 text-xs bg-neutral-100 p-3 overflow-auto max-h-40" data-testid="app-error-message">{String(this.state.error?.message || this.state.error)}</pre>
          <div className="mt-5 flex gap-2">
            <button data-testid="app-error-reload" onClick={() => window.location.reload()} className="bg-black text-white px-4 py-2 text-sm hover:bg-neutral-800">Reload</button>
            <a href="/" data-testid="app-error-home" className="border border-black px-4 py-2 text-sm hover:bg-black hover:text-white transition-colors">Go to dashboard</a>
          </div>
        </div>
      </div>
    );
  }
}
